module.exports = __webpack_public_path__ + "static/media/azuredevopsIcon.d4e12d08.svg";